<div class="chat-header">
  @if (showHistory()) {
    <button mat-icon-button (click)="showHistory.set(false)" matTooltip="Back to chat">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h3>Chat History</h3>
  } @else {
    <mat-icon style="margin-right: 8px; opacity: 0.7">smart_toy</mat-icon>
    <h3>AI Financial Advisor</h3>
    <button mat-icon-button (click)="toggleHistory()" matTooltip="Chat history">
      <mat-icon>history</mat-icon>
    </button>
    <button mat-icon-button (click)="clearConversation()" matTooltip="New conversation">
      <mat-icon>add_comment</mat-icon>
    </button>
  }
  <button mat-icon-button (click)="close.emit()" matTooltip="Close">
    <mat-icon>close</mat-icon>
  </button>
</div>

@if (chatService.error()) {
  <div class="error-bar">⚠️ {{ chatService.error() }}</div>
}

@if (showHistory()) {
  <div class="session-list">
    @if (chatService.sessions().length === 0) {
      <div class="empty-state">
        <mat-icon>chat_bubble_outline</mat-icon>
        <span>No previous conversations</span>
      </div>
    }
    @for (session of chatService.sessions(); track session.id) {
      <div class="session-item">
        <div
          class="session-info"
          role="button"
          tabindex="0"
          (click)="openSession(session.id)"
          (keydown.enter)="openSession(session.id)"
        >
          <span class="session-title">{{ sessionLabel(session) }}</span>
          <span class="session-meta">{{ sessionMeta(session) }}</span>
        </div>
        <button
          mat-icon-button
          class="delete-btn"
          (click)="deleteSession(session.id)"
          matTooltip="Delete chat"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    }
  </div>
} @else {
  @if (chatService.messages().length === 0) {
    <div class="empty-state">
      <mat-icon>smart_toy</mat-icon>
      <strong>Financial AI Advisor</strong>
      <span
        >Ask me about your transactions, invoices, tax estimates, or anything about your
        finances.</span
      >
    </div>
  } @else {
    <div class="messages">
      @for (msg of chatService.messages(); track msg.id) {
        <div class="message {{ msg.role }}">
          @if (msg.role === "assistant") {
            <span [innerHTML]="msg.content | markdown"></span>
          } @else {
            {{ msg.content }}
          }
          @if (msg.isStreaming) {
            <span class="typing-indicator"><span></span><span></span><span></span></span>
          }
        </div>
      }
      <div #messagesEnd></div>
    </div>
  }

  <div class="input-row">
    <textarea
      cdkTextareaAutosize
      cdkAutosizeMinRows="1"
      cdkAutosizeMaxRows="6"
      [value]="inputText()"
      (input)="inputText.set($any($event.target).value)"
      (keydown)="onKeydown($event)"
      placeholder="Ask about your finances…"
      [disabled]="chatService.isStreaming()"
    ></textarea>
    @if (chatService.isStreaming()) {
      <mat-progress-spinner diameter="32" mode="indeterminate" />
    } @else {
      <button
        mat-icon-button
        color="primary"
        [disabled]="!inputText().trim()"
        (click)="send()"
        matTooltip="Send (Enter)"
      >
        <mat-icon>send</mat-icon>
      </button>
    }
  </div>
}
